import { render, staticRenderFns } from "./file-widget.vue?vue&type=template&id=5599d0ea&scoped=true"
import script from "./file-widget.vue?vue&type=script&lang=js"
export * from "./file-widget.vue?vue&type=script&lang=js"
import style0 from "./file-widget.vue?vue&type=style&index=0&id=5599d0ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5599d0ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5599d0ea')) {
      api.createRecord('5599d0ea', component.options)
    } else {
      api.reload('5599d0ea', component.options)
    }
    module.hot.accept("./file-widget.vue?vue&type=template&id=5599d0ea&scoped=true", function () {
      api.rerender('5599d0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/file-widget.vue"
export default component.exports